<template>
  <div class="outer-wrapper">
    <div class="report-wrapper" v-if="toggleShow==='operate'">
      <van-nav-bar
        :title="sampleDisplayNoAbbr(sub_sample_display_no)"
        
        fixed
      ></van-nav-bar>
      <van-cell title="样品名称" :value="currentSample.sample_name" />
      <van-cell title="型号" :value="currentSample.sample_model?currentSample.sample_model:'无'" />
      <van-panel title="其他属性：" desc status>
        <div class="d-wrapper">
          <p>{{currentSample.other_property?currentSample.other_property:'无'}}</p>
        </div>
      </van-panel>
      <van-cell title="样品个数" :value="currentSample.amount" />
      <van-cell title="当前状态" :value="currentSample.stat" />
      <van-cell title="上次操作" :label="currentSample.flow" is-link clickable @click="toFlow"/>
      <van-panel title="上传样品图片：" desc status v-show="statList.imgValidList.includes(choosed.operation)">
        <div class="d-wrapper">
          <van-uploader
            :after-read="handleAfterRead"
            :before-delete="handleBeforeDelete"
            deletable
            v-model="imgList"
            capture="camera"
          />
        </div>
      </van-panel>
      <van-panel title="选择操作：" desc status>
        <div class="d-wrapper">
          <van-radio-group v-model="choosed.operation">
            <van-radio
              :name="ele"
              class="radio-item"
              v-for="ele in statList[currentSample.stat]"
              :key="ele+'stat'"
            >{{ele}}</van-radio>
          </van-radio-group>
        </div>
      </van-panel>
      <van-panel title="选择发出目的地：" desc status v-show="statList.sendValidList.includes(choosed.operation)">
      <div class="d-wrapper">
          <van-radio-group v-model="choosed.target">
            <van-radio
              :name="ele"
              class="radio-item"
              v-for="ele in statList.send.target"
              :key="ele+'stat'"
            >{{ele}}</van-radio>
          </van-radio-group>
        </div>
         </van-panel>
         <van-panel title="选择发出方式：" desc status v-show="statList.sendValidList.includes(choosed.operation)">
        <div class="d-wrapper">
          <van-radio-group v-model="choosed.method">
            <van-radio
              :name="ele"
              class="radio-item"
              v-for="ele in statList.send.method"
              :key="ele+'stat'"
            >{{ele}}</van-radio>
          </van-radio-group>
        </div>
        </van-panel>
        <van-panel title="选择检测项目：" desc status v-show="test.testValidList.includes(choosed.operation)">
        <div class="d-wrapper">
          <van-radio-group v-model="choosed.product">
            <van-radio
              :name="ele"
              class="radio-item"
              v-for="ele in test.productList"
              :key="ele.sub_choice+'stat'"
            >{{ele.sub_choice}}</van-radio>
          </van-radio-group>
        </div>
        </van-panel>
        <van-panel title="选择检测设备：" desc status v-show="test.testValidList.includes(choosed.operation)">
        <div class="d-wrapper">
          <van-radio-group v-model="choosed.equipment">
            <van-radio
              :name="ele"
              class="radio-item"
              v-for="ele in test.usedEquipmentList"
              :key="ele.equipnum+'stat'"
            >{{ele.equipnum+' '+ele.name}}</van-radio>
            <p @click="toEquipment" class="more-equipment">更多设备</p>
            
          </van-radio-group>
        </div>
        </van-panel>
        <van-panel title="填写备注：" desc status>
        <div class="d-wrapper">
         <van-field
          v-model="remark"
          rows="2"
          autosize
          label="备注"
          type="textarea"
          maxlength="100"
          placeholder="请输入备注"
          show-word-limit
        />
        </div>
        </van-panel>
      <div class="button-wrapper">
        <van-button color="#ee0a24" class="submit" @click="checkSubmit" :disabled="!submitAbled">提交</van-button>
        <van-button
          color="#ee0a24"
          class="submit"
          plain
          style="margin-left:1rem;"
          @click="handleCancel"
        >重置</van-button>
      </div>
    </div>
    <div class="flow-wrapper" v-else-if="toggleShow==='flow'">
      <van-nav-bar
        :title="'操作记录('+sampleDisplayNoAbbr(sub_sample_display_no)+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack"
        fixed
      ></van-nav-bar>
      <div class="flow-ele-wrapper">
        <div class="flow-ele" v-for="(ele,index) in flowList" :key="index">
          <p>
            <span class="time-span">{{ele.operate_time}}</span>
            <span>{{ele.operator_name}}</span>
            <span>{{ele.operate_text}}</span>
            </p>
        </div>
      </div>
    </div>
    <div class="flow-wrapper" v-else-if="toggleShow==='equipment'">
      <van-nav-bar
        :title="'选择设备('+sampleDisplayNoAbbr(sub_sample_display_no)+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack"
        fixed
      ></van-nav-bar>
      <div class="flow-ele-wrapper">
        <div class="d-wrapper">
          <van-radio-group v-model="moreEquipment">
              <van-radio
              :name="ele"
              class="radio-item"
              v-for="ele in test.equipmentList"
              :key="ele.equipnum+'state'"
            >{{ele.equipnum+' '+ele.name}}</van-radio>
          </van-radio-group>
        </div>
      </div>

    </div>
    <div class="spin" v-else>
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";
//let authData = JSON.parse(localStorage.getItem("authData"));

function choosedFac(){
  return {
    operation:'',
        target:'',
        method:'',
        product:'',
        equipment:''
  };
}

export default {
  name: "subSampleDo",
  components: {},
  mixins: [textTrans],
  props:{
    sub_sample_display_no:{
      type: String,
      default: ''
    }

  },
  data() {
    return {
      toggleShow:'operate',
      currentSample: {},
      currentSampleCompare: {},
      imgList: [],
      choosed: choosedFac(),
      remark:'',
      statList: {
        send:{},
        imgValidList:[],
        sendValidList:[]
      },
      test:{
        equipmentList:[],
        usedEquipmentList:[],
        testValidList:[],
        productList:[]
      },
      flowList:[],
      more:false,
      moreEquipment:null
    };
  },
  watch: {
    moreEquipment:function(value){
      if(!this.test.usedEquipmentList.find(val=>val.equipnum===value.equipnum)){
        this.test.usedEquipmentList.push(value);
      }
      this.choosed.equipment = value;
      this.toggleShow = 'operate';
    }
  },
  computed: {
    submitAbled: function() {
      if(this.choosed.operation){
        if(this.statList.sendValidList.includes(this.choosed.operation)&&this.choosed.target&&this.choosed.method){
          return true;
        }else if(!this.statList.sendValidList.includes(this.choosed.operation)){
          if(this.test.testValidList.includes(this.choosed.operation)&&this.choosed.product&&this.choosed.equipment){
            return true;
          }else if(!this.test.testValidList.includes(this.choosed.operation)){
            return true;
          }else{
            return false;
          }
        }else{
          return false;
        }
      }else{
        return false;
      }
    }
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.$axios
        .post(this.$url + "/inspection_do", {
          userToken: userToken,
          ask_data: "subSampleInfo",
          display_no:this.sub_sample_display_no
        })
        .then(response => {
          if(response.data.stat==='ok'){
            this.currentSample = response.data.res_record;
            this.statList = response.data.statList;
            this.test = response.data.test;
          }else{
            this.$toast.fail('未找到数据！');
          }
        });
    },
    checkSubmit() {
      this.toggleShow = 'spin';
      if (this.submitAbled) {
        let form = new FormData();
        form.append("userToken", userToken);
        form.append("askData", 'subSampleDo');
        form.append("sub_sample_display_no", this.sub_sample_display_no);
        form.append("remark", this.remark);
        form.append("choosed", JSON.stringify(this.choosed));
        for (let img of this.imgList) {
          if (img.obj !== undefined) {
            form.append("sampleImg", img.obj);
          }
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/inspection_do", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              window.location.href = '/allot_success';
                this.$toast.success("样品信息更新成功！");
            } else {
              this.$toast.fail(response.data.error_info);
            }
          })
          .catch(error => {
            this.$toast.fail(error + "网络连接失败！");
          });
      }
    },
    handleAfterRead(img, detail) {
      if (img.file.size < 1024 * 200) {
        this.imgList[detail.index].obj = img.file;
      } else {
        let vm = this;
        var reader = new FileReader();
        reader.readAsDataURL(img.file);
        reader.onload = function(e) {
          let img = new Image();
          img.src = e.target.result;
          img.onload = function() {
            let width = 800, //图像大小
              quality = 0.7, //图像质量
              canvas = document.createElement("canvas"),
              drawer = canvas.getContext("2d");
            canvas.width = width;
            canvas.height = width * (img.height / img.width);
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            vm.imgList[detail.index].url = canvas.toDataURL(
              "image/jpeg",
              quality
            );
            vm.imgList[detail.index].obj = vm.convertBase64UrlToFile(
              vm.imgList[detail.index].url,
              "img" + detail.index + ".jpeg"
            );
            this.imgAlter = true;
          };
        };
      }
    },
    handleBeforeDelete(img) {
      if(img){
        return true;
      }else{
        return false;
      } 
    },
    convertBase64UrlToFile(urlData, filename) {
      let arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCancel(){
      this.choosed = choosedFac();
    },
    toFlow(){
      this.toggleShow = 'spin';
      this.$axios
        .post(this.$url + "/inspection_do", {
          userToken: userToken,
          ask_data: "subSampleFlow",
          display_no:this.sub_sample_display_no
        })
        .then(response => {
          if(response.data.stat==='ok'){
            this.flowList = response.data.res_record;
            this.toggleShow = 'flow';
          }else{
            this.$toast.fail('未找到数据！');
          }
        });
    },
    onClickBack(){
      this.toggleShow = 'operate';
    },
    toEquipment(){
      this.toggleShow = 'equipment';
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem 0.5rem 0;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}

.flow-ele{
  font-size: 0.6rem;
  padding: 0.2rem 0.6rem;
  border-bottom:1px solid #ccc; 
}

.flow-ele span{
  margin-right:0.6rem;
}
.time-span{
  color:#999;
}
.flow-wrapper{
  padding: 0.6rem 0;
}
.spin{
  text-align: center;
  padding-top: 40%;
  
}
.more-equipment{
  margin:1rem;
}
</style>